import crypto from "crypto";

export function generateTicketHash(uid = '') {
  let ticketNumber = '';
  const timestamp = new Date().getTime().toString();

  ticketNumber = crypto.createHash('sha1').update(JSON.stringify(uid.concat(timestamp))).digest('hex').substring(0, 7);

  return ticketNumber;
}